











































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import "echarts-gl";
import echarts from "echarts";
@Component({
    ...mapGetters(["account"]),
    components: {
    }
})
export default class ChartOne extends Vue {
    @Prop([String, Date])
    dateTime!: string;

    year: string = ""
    accountCharge: string[] = [];
    bookCharge: string[] = [];
    otherCharge: string[] = [];
    totalIncome: string[] = [];
    yearAccountCharge: number = 0;
    yearBookCharge: number = 0;
    yearOtherCharge: number = 0;
    yearTotalIncome: number = 0;
    mounted() {
        this.year = this.dateTime
        this.fetchData()
    }
    // 监听时间切换
    @Watch("dateTime")
    dateTimeChange(val: string) {
        this.year = val;
        this.fetchData();
    }
    // 获取数据
    tableData: Analysis.Analysis[] = []
    fetchData() {
        this.accountCharge = [];
        this.bookCharge = [];
        this.otherCharge = [];
        this.totalIncome = [];
        Vue.axios
            .post(`analysis/income`, {
                endPeriod: this.year,
                accounterNo: this.$store.state.account.no,
            })
            .then(res => {
                this.tableData = res.data.data;
                Object.keys(res.data.data[0]).forEach(attr => {
                    if (attr != "chargeType" && attr != "total") {
                        // @ts-ignore
                        this.accountCharge.push(this.$utils.currency(res.data.data[0][attr], true, ""));
                        // @ts-ignore
                        this.bookCharge.push(this.$utils.currency(res.data.data[1][attr], true, ""));
                        // @ts-ignore
                        this.otherCharge.push(this.$utils.currency(res.data.data[2][attr], true, ""));
                        // @ts-ignore
                        this.totalIncome.push(this.$utils.currency(res.data.data[3][attr], true, ""));
                    }
                });
                this.yearAccountCharge = res.data.data[0]["total"];
                this.yearBookCharge = res.data.data[1]["total"];
                this.yearOtherCharge = res.data.data[2]["total"];
                this.yearTotalIncome = res.data.data[3]["total"];
                this.canvasShow("canvas", this.yearAccountCharge, this.yearBookCharge, this.yearOtherCharge);
                this.loadChart();
            });
    }
    // canvas 饼状图
    option: any = {};
    canvasShow(id: string, num1: number, num2: number, num3: number) {
        let c: any = document.getElementById(id);
        let ctx = c.getContext("2d");
        if ((num1 + num2 + num3) == 0) {
            ctx.lineWidth = 18;
            ctx.strokeStyle = "grey";
            ctx.beginPath();
            ctx.arc(80, 80, 70, -Math.PI / 2, 3 * Math.PI / 2, false);
            ctx.stroke();
            ctx.closePath();
            return
        }
        let end1 = num1 / (num1 + num2 + num3) * 360 - 90;
        let end2 = (num2 + num1) / (num1 + num2 + num3) * 360 - 90;

        ctx.lineWidth = 18;
        ctx.strokeStyle = "#34c2c1";
        ctx.beginPath();
        ctx.arc(80, 80, 70, -Math.PI / 2, Math.PI / 180 * end1, false);
        ctx.stroke();
        ctx.closePath();

        ctx.lineWidth = 18;
        ctx.strokeStyle = "#ffc339";
        ctx.beginPath();
        ctx.arc(80, 80, 70, Math.PI / 180 * end1, Math.PI / 180 * end2, false);
        ctx.stroke();
        ctx.closePath();

        ctx.lineWidth = 18;
        ctx.strokeStyle = "#fd7646";
        ctx.beginPath();
        ctx.arc(80, 80, 70, Math.PI / 180 * end2, 3 * Math.PI / 2, false);
        ctx.stroke();
        ctx.closePath();
    }
    // 收入趋势图
    loadChart() {
        let color = "#333";
        this.option = {
            title: {
                text: "收入趋势图",
                textStyle: {
                    color: color,
                    fontSize: "15"
                },
                left: "center",
                top: "8"
            },
            tooltip: {
                trigger: "axis",
                formatter: "{a0}: {c0}万元<br />{a1}: {c1}万元<br />{a2}: {c2}万元<br />{a3}: {c3}万元",
                axisPointer: {
                    type: "line"
                }
            },
            grid: {
                top: "60",
                bottom: "40"
            },
            legend: {
                data: [
                    { name: "记账费", icon: "circle" },
                    { name: "账本费", icon: "circle" },
                    { name: "其他费用", icon: "circle" },
                    { name: "总收入", icon: "circle" }
                ],
                textStyle: { fontSize: "12", color: color },
                itemWidth: 6,
                itemHeight: 6,
                orient: "vertical",
                right: "0",
                top: "35%",
            },
            xAxis: [
                {
                    type: "category",
                    data: [
                        { value: "1月", textStyle: { color: color } },
                        { value: "2月", textStyle: { color: color } },
                        { value: "3月", textStyle: { color: color } },
                        { value: "4月", textStyle: { color: color } },
                        { value: "5月", textStyle: { color: color } },
                        { value: "6月", textStyle: { color: color } },
                        { value: "7月", textStyle: { color: color } },
                        { value: "8月", textStyle: { color: color } },
                        { value: "9月", textStyle: { color: color } },
                        { value: "10月", textStyle: { color: color } },
                        { value: "11月", textStyle: { color: color } },
                        { value: "12月", textStyle: { color: color } }
                    ],
                    axisLine: {
                        lineStyle: {
                            color: "#dedede"
                        }
                    },
                    axisTick: {
                        lineStyle: {
                            color: "white"
                        }
                    },
                }
            ],
            yAxis: [
                {
                    type: "value",
                    offset: 10,
                    axisLine: {
                        show: false,
                    },
                    axisTick: {
                        lineStyle: {
                            color: "white"
                        }
                    },
                    axisLabel: {
                        formatter(value: string, index: number) {
                            if (index === 0) {
                                return value + " (万元)";
                            } else {
                                return value;
                            }
                        },
                        color: color
                    },
                    splitLine: {
                        lineStyle: {
                            color: "#eeeeee"
                        }
                    }
                },
                {
                    show: false,
                }
            ],
            series: [
                {
                    name: "记账费",
                    type: "bar",
                    data: this.accountCharge,
                    itemStyle: {
                        normal: {
                            color: "#34c2c1"
                        },
                    }
                },
                {
                    name: "账本费",
                    type: "bar",
                    data: this.bookCharge,
                    itemStyle: {
                        normal: {
                            color: "#ffc339"
                        }
                    }
                },
                {
                    name: "其他费用",
                    type: "bar",
                    data: this.otherCharge,
                    itemStyle: {
                        normal: {
                            color: "#fd7645"
                        }
                    }
                },
                {
                    name: "总收入",
                    type: "line",
                    data: this.totalIncome,
                    lineStyle: {
                        normal: {
                            color: "#e02f12"
                        }
                    },
                }
            ]
        };
        // this.option.setOption({ notMerge: true, lazyUpdate: false, silent: false, })
    }
}
